import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/security"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 2C13.375 2.8 15.5 3.2 15.5 3.2L15.0764 7.41676C14.6823 11.3405 12.019 14.6663 8.27613 15.9084L8 16H7.99995L7.72387 15.9084H7.72382C4.16792 14.7283 1.58636 11.6676 0.99939 8H0.999443C0.968587 7.8072 0.943242 7.61272 0.923558 7.41676L0.5 3.2C0.5 3.2 2.625 2.8 4.5 2C6.36876 1.20266 7.98919 0.00797831 7.99995 3.97687e-05V0C7.99995 0 7.99996 6.45518e-06 7.99997 1.93456e-05C7.99999 6.45518e-06 8 0 8 0C8 0 9.625 1.2 11.5 2ZM7.99995 2.40422C7.31 2.83442 6.34448 3.38746 5.28488 3.83956C4.37194 4.22908 3.42886 4.52664 2.66453 4.73776L2.91354 7.21687C2.94013 7.48155 2.97962 7.74283 3.03145 8H7.99995V13.8835C7.99996 13.8835 7.99998 13.8835 8 13.8835C10.5609 12.8985 12.4302 10.6712 12.9685 8H7.99995V2.40422Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Security16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Security16 = createIcon(IconComponent);